/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Astras Copilot",
  "description": "AI copilot for Scratch mods, supports any OpenAI-compatible API. Theme follows editor in real-time.",
  "tags": ["new"],
  "credits": [
    {
      "name": "NeuronPulse",
      "link": "https://github.com/NeuronPulse"
    }
  ],

  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
